import { createContext, useContext, useState } from 'react';

const PeriodContext = createContext(null);

export function PeriodProvider({ children }) {
  const [selMonth, setSelMonth] = useState(new Date().getMonth());
  const [selYear, setSelYear] = useState(new Date().getFullYear());
  return (
    <PeriodContext.Provider value={{ selMonth, setSelMonth, selYear, setSelYear }}>
      {children}
    </PeriodContext.Provider>
  );
}

export function usePeriod() {
  const ctx = useContext(PeriodContext);
  if (!ctx) throw new Error('usePeriod must be used within PeriodProvider');
  return ctx;
}
